
<template>
  <div :class="hidedata?'r-d l-cont-c r-dr':'r-d l-cont-c'"  v-loading="loadingRight" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="l-t hh3">
        <h3  v-html="itemData.highSpeedName"></h3>
        <span>途径城市数据</span>
      </div>
      <div class="l-cont l-cont-p" style="height: 410px;">
        <div v-for="(i,k) in listDataRi" :key="k" style="margin-top:0;">
          <div class="rdata">
            <div>
              <div>运营车次（日均）</div>
              {{i.operationsRange}}
              <span>次</span>
            </div>
            <div>
              <div>加油站停靠（日均）</div>
              {{i.gasStationRange}}
              <span>次</span>
            </div>
            <div>
              <div>物流园停靠（日均）</div>
              {{i.logisticsPark}}
              <span>次</span>
            </div>
            <div>
              <div>道路加油站密度（座/百公里）</div>
              {{i.density}}
            </div>
            <div>
              <div>LNG车次（日均）</div>
              {{i.lugNumber}}
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
 
<script>
export default {
  data() {
    return {
      loading: true,
      // listDataRi: []
    }
  },
  props: {
    loadingRight: Boolean,
    itemData: Object,
    hidedata: Boolean,
    clickId: Number,
    listDataRi:{
      type: Array,
      default: () => {
        return []
      }
    },
  },

  watch: {},
  created() {
    // if (this.itemData.listData) {
    //   this.listDataRi = this.itemData.listData
    //   console.log(this.listDataRi)
    // }
  },
  methods: {}
}
</script>
 
<style scoped>
.rdata {
  font-size: 18px;
}
.rdata > div {
  padding: 20px 0;
  border-bottom: 1px solid #393a55;
  padding-bottom: 30px;
}
.rdata > div:first-child{
  padding-top: 0;
}
.rdata > div:last-child{
  padding-bottom: 0;
  border-bottom: none
}
.l-cont-p {
  padding-bottom: 0px;
}
.rdata span {
  font-size: 10px;
  opacity: 0.8;
  margin-left: 5px;
}
.rdata div div {
  font-size: 10px;
  opacity: 0.5;
  padding-bottom: 10px;
}
.hh3{
  padding:0 30px;
  height: 120px;
}
.hh3 h3{
  margin-bottom: 15px;
  padding-top: 30px;
}
.l-cont-c {
  height: auto;
  padding-bottom: 20px;
}
</style>